<div class="wrapper">
    <app-report-single-header />

    <div class="reportContainer">
        @if (configuration()) {
            <app-report-single-filters />

            @if (showContent()) {
                <app-report-single-tabs />
            } @else {
                <app-report-single-empty-state />
            }
        }
    </div>
</div>
